import axios from 'axios';
import { PAGOS_PROYECTOS } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const listarPagos = (filtros = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_proyecto: filtros.id_proyecto ?? null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/pagos_proyectos/listar`, body, config);

        await dispatch({
            type: PAGOS_PROYECTOS.LISTAR,
            payload: res.data?.pagos || []
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PAGOS_PROYECTOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al listar los pagos', 'danger'));
        return false;
    }
};

export const filtrarPagos = (texto = '') => dispatch => {
    dispatch({
        type: PAGOS_PROYECTOS.FILTRAR,
        payload: texto
    });
};

export const limpiarPagos = () => dispatch => {
    dispatch({ type: PAGOS_PROYECTOS.LIMPIAR });
};

export const crearPago = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_proyecto: data.id_proyecto || '',
        fecha: data.fecha || null,
        monto: data.monto ?? '',
        metodo_pago: data.metodo_pago || '',
        referencia: data.referencia || null,
        observaciones: data.observaciones || null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/pagos_proyectos/crear`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo registrar el pago', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Pago registrado correctamente', 'success'));

        await dispatch(listarPagos({ id_proyecto: data.id_proyecto }));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PAGOS_PROYECTOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al registrar el pago', 'danger'));
        return false;
    }
};

export const editarPago = (data = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id: data.id || '',
        fecha: data.fecha || null,
        monto: data.monto ?? '',
        metodo_pago: data.metodo_pago || '',
        referencia: data.referencia || null,
        observaciones: data.observaciones || null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/pagos_proyectos/editar`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo editar el pago', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Pago editado correctamente', 'success'));

        await dispatch(listarPagos({ id_proyecto: data.id_proyecto }));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PAGOS_PROYECTOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al editar el pago', 'danger'));
        return false;
    }
};

export const eliminarPago = (id, id_proyecto) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/pagos_proyectos/eliminar`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo eliminar el pago', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Pago eliminado correctamente', 'success'));

        await dispatch(listarPagos({ id_proyecto }));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PAGOS_PROYECTOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al eliminar el pago', 'danger'));
        return false;
    }
};
